module.exports = "<main-layout></main-layout>"